import { loader } from 'graphql.macro'

export default async function deleteTermsAndCondition ({ dataLoaders, variables }) {
  const schema = loader('./deleteTermsAndCondition.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      id: variables.id
    }
  })
  return response.deleteTermsAndCondition
}
